import React from 'react';
import { useWatch } from 'react-hook-form';
import { Button, Stack } from '@mui/material';
import { AddCircle, FileCopy } from '@mui/icons-material';
import { AftermarketLicenceType } from '@trnsact/trnsact-shared-types';
import { AftermarketProductPermissions } from 'modules/aftermarket';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { initialConfigRow } from '../../../constants';
import { ProductConfigListingContext } from '../../../types';

interface Props {
  context: ProductConfigListingContext;
}

export const BottomActionPanel = ({ context }: Props) => {
  const { isReadOnly, handleAddRow, aftermarketLicenceType, handleCopyLastConfig, form } = context;

  const configsCount = useWatch({ control: form.control, name: 'bodyFields' }).length;
  const isProLimitReached = aftermarketLicenceType === AftermarketLicenceType.Pro && configsCount > 0;

  return (
    <Stack direction="row" gap="0.5rem">
      <AftermarketProductPermissions licenceType={[AftermarketLicenceType.Enterprise, AftermarketLicenceType.Pro]}>
        <RenderWithCondition condition={!isProLimitReached}>
          <Button
            size="small"
            startIcon={<AddCircle />}
            disabled={isReadOnly}
            onClick={() => handleAddRow(initialConfigRow)}
          >
            Add new Configuration
          </Button>
        </RenderWithCondition>
      </AftermarketProductPermissions>

      <AftermarketProductPermissions licenceType={[AftermarketLicenceType.Enterprise]}>
        <Button size="small" disabled={isReadOnly} startIcon={<FileCopy />} onClick={handleCopyLastConfig}>
          Copy last Configuration
        </Button>
      </AftermarketProductPermissions>
    </Stack>
  );
};
